import {createRouter, createWebHistory} from 'vue-router'
import {routes} from './routes';
import {Component} from "vue";

export {pages as AppPages} from './pages';
export * from './types';

const index = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
});

export function useRouter() {
    return index;
}

declare module 'vue-router' {
    interface RouteMeta {
        title?: string;
        icon?: Component;
        isHide?: boolean;
        isNavTab?: boolean;
        divider?: 'before' | 'after';
        isNew?: boolean;
    }
}
